<template>
	<v-card>
		<v-card-title class="blue">
    <h1 class="white--text">
      <span class="botter-twitter-icon"></span>
      Twitter App Config
    </h1>
    </v-card-title>
    <v-card-text>
      <v-form>
      <label>Env Name</label>
      <v-text-field
        v-model = "input.env_name"
        placeholder="Env Name"
        outline />
      <label>Screen Name</label>
      <v-text-field
        v-model = "input.screen_name"
        placeholder="Page Id"
        outline />
      <label>Consumer Key</label>
      <v-text-field
        v-model = "input.consumer_key"
        placeholder="Consumer Key"
        outline />
      <label>Consumer Secret</label>
      <v-text-field
        v-model = "input.consumer_secret"
        placeholder="App Secret"
        outline />
      <label>Access Token</label>
      <v-text-field
        v-model = "input.access_token"
        placeholder="Access Token"
        outline />
      <label>Access Token Secret</label>
      <v-text-field
        v-model = "input.access_token_secret"
        placeholder="Access Token Secret"
        outline />
    </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn @click="$emit('closed')">Close</v-btn>
      <v-btn class="blue white--text" @click="updateApp">Save</v-btn>
    </v-card-actions>
	</v-card>
</template>

<script>
export default {

  name: 'TwitterNotificationsConfig',
  props: {
  	screenName: {
  		type: String,
  		required: true
  	}
  },
  data () {
    return {
    	appData: null,
      input: {
        env_name: '',
        screen_name: '',
        consumer_key: '',
        access_token: '',
        access_token_secret: '',
        consumer_secret: '',
      }
    }
  },
  computed: {
  	botId() {
  		return this.$store.state.bot.botId
  	}
  },
  mounted() {
  	this.getApp()
  },
  methods: {
  	getTwitterApps() {
  		this.getApps()
  	},
  	async getApp() {
      this.$store.dispatch('setLoader', true)
  		this.$http_chat.get(`/bots/apps/twitter/${this.screenName}`).then(({ data }) =>{
        this.$store.dispatch('setLoader', false)
        if(data.twitter_apps && data.twitter_apps.length) {
          this.appData = data.twitter_apps[0]
          this.input = data.twitter_apps[0]
        } else {
          this.$store.dispatch('setErrorMessage', true)
          this.$store.dispatch('setLoader', false)
        }
      }).catch(()=>{
        this.$store.dispatch('setErrorMessage', true)
        this.$store.dispatch('setLoader', false)
      })
  	},
    updateApp() {
      this.$store.dispatch('setLoader', true)
      const payload = this.$_.omit(this.input, ['_id'])
      this.$http_chat.put(`/bots/${this.botId}/apps/twitter`, payload).then(({ data })=>{
        this.$store.dispatch('setSnackbar', {
            text: `Updated Successfully`,
            color: 'success'
          })
          this.$store.dispatch('setLoader', false)
          this.$emit('success', data)
      }).catch(()=>{
        this.$store.dispatch('setLoader', false)
        this.$store.dispatch('setErrorMessage', true)
      })
    }
  }
}
</script>

<style lang="css" scoped>
</style>